<template>
  <div class="card">
    <!-- Header Bar -->
    <div class="header-bar">
      <button class="btn secondary" @click="$router.back()">⬅ Kembali</button>
      <h3>Tambah Nasabah <span v-html="nama_bank" class="text-orange"></span></h3>
    </div>

    <!-- Form Container -->
    <div class="form-container">
      <form @submit.prevent="onSave()" class="form-grid">
        <!-- Kolom Kiri -->
        <div class="form-column">
          <div class="form-group">
            <label>NOPEN <span class="required">*</span></label>
            <input
              type="text"
              v-model="form.nopen"
              required
              @input="form.nopen = form.nopen.replace(/\D/g, '').slice(0, 20)"
              placeholder="Masukkan nomor pendaftaran"
            />
          </div>

          <div class="form-group">
            <label>KTP Nasabah <span class="required">*</span></label>
            <input
              type="text"
              v-model="form.ktp_nasabah"
              required
              @input="form.ktp_nasabah = form.ktp_nasabah.replace(/\D/g, '').slice(0, 19)"
              placeholder="Masukkan KTP Nasabah"
            />
          </div>

          <div class="form-group">
            <label>Nama Nasabah <span class="required">*</span></label>
            <input
              type="text" 
              v-model="form.nama_nasabah"
              @input="form.nama_nasabah = form.nama_nasabah.slice(0, 45)"
              placeholder="Masukkan Nama Nasabah" 
              required 
            />
          </div>

          <div class="form-group">
            <label>Tanggal Pengajuan <span class="required">*</span></label>
            <input type="date" v-model="form.tgl_pengajuan" required />
          </div>

          <div v-if="kode_bank != 1" class="form-group">
            <label>Tanggal Pencairan</label>
            <input type="date" v-model="form.tgl_pencairan" />
          </div>

          <div class="form-group">
            <label>Jenis Pengajuan <span class="required">*</span></label>
            <select v-model="form.jenis_pengajuan" required>
              <option value="">-- Pilih Jenis Pengajuan --</option>
              <option :value="item.id" v-for="(item, index) in arrJenisPengajuan" :key="index">
                {{ item.jenis_pengajuan }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Jenis PK <span class="required">*</span></label>
            <select v-model="form.jenis_pk" required>
              <option value="">-- Pilih Jenis PK --</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
            </select>
          </div>
          
          <div class="form-group">
            <label>Plafond <span class="required">*</span></label>
            <input
              type="text"
              v-model="displayPlafond"
              @input="formatCurrency($event, 'plafond', 'displayPlafond', 9)"
              @keyup="onReber()"
              placeholder="0"
              required
            />
          </div>

          <div class="form-group">
            <label>Bakidebet</label>
            <input
              type="text"
              v-model="displayBakidebet"
              @input="formatCurrency($event, 'bakidebet', 'displayBakidebet', 9)"
              @keyup="onReber()"
              placeholder="0"
            />
          </div>

          <div class="form-group">
            <label>Realisasi Bersih</label>
            <input 
              type="text"
              v-model="displayReber"
              @input="formatNumber"
              placeholder="0"
              readonly
              class="readonly-input"
            />
          </div>
        </div>

        <!-- Kolom Kanan -->
        <div class="form-column">
          <div class="form-group">
            <label>Jangka Waktu (Bulan) <span class="required">*</span></label>
            <input
              type="text"
              v-model="form.jangka_waktu"
              required
              @input="form.jangka_waktu = form.jangka_waktu.replace(/\D/g, '').slice(0, 3)"
              placeholder="Masukkan Jangka Waktu"
            />
          </div>

          <div class="form-group">
            <label>Cabang <span class="required">*</span></label>
            <vue-select
              v-model="form.cabang"
              :options="arrCabang"
              label="nama"
              :reduce="item => item.id"
              placeholder="-- Pilih Cabang --"
            ></vue-select>
          </div>

          <div class="form-group">
            <label>Jenis Produk <span class="required">*</span></label>
            <select v-model="form.jenis_produk" required>
              <option value="">-- Pilih Jenis Produk --</option>
              <option :value="item.id" v-for="(item, index) in arrJenisProduk" :key="index">
                {{ item.nama_produk }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Instansi <span class="required">*</span></label>
            <input 
              type="text" 
              v-model="form.kerja_nasabah" 
              @input="form.kerja_nasabah = form.kerja_nasabah.slice(0, 100)"
              placeholder="Masukkan Instansi" 
              required 
            />
          </div>

          <div class="form-group">
            <label>Tipe Debitur <span class="required">*</span></label>
            <select v-model="form.tipe_debitur" required>
              <option value="">-- Pilih Tipe Debitur --</option>
              <option :value="item.id" v-for="(item, index) in arrTipeDebitur" :key="index">
                {{ item.tipe_debitur }}
              </option>
            </select>
          </div>

          <div v-if="kode_bank != 2" class="form-group switch-group">
            <label for="take-offer" class="checkbox-label">Take Over</label>
            <label class="switch">
              <input 
                type="checkbox" 
                id="take-offer" 
                v-model="form.takeoffer"
              >
              <span class="slider"></span>
            </label>
          </div>

          <div class="form-group">
            <label>Nama HS <span class="required">*</span></label>
            <input 
              type="text" 
              v-model="form.nama_hs" 
              @input="form.nama_hs = form.nama_hs.slice(0, 45)"
              placeholder="Masukkan Nama HS" 
              required 
            />
          </div>

          <div class="form-group">
            <label>Nama TL <span class="required">*</span></label>
            <input 
              type="text" 
              v-model="form.nama_tl" 
              @input="form.nama_tl = form.nama_tl.slice(0, 45)"
              placeholder="Masukkan Nama TL" 
              required 
            />
          </div>

          <div class="form-group">
            <label>Nama MR <span class="required">*</span></label>
            <input 
              type="text" 
              v-model="form.nama_mr" 
              @input="form.nama_mr = form.nama_mr.slice(0, 45)"
              placeholder="Masukkan Nama MR" 
              required 
            />
          </div>

          <div v-if="kode_bank == 2" class="form-group">
            <label>Nama Fee Marketing <span class="required">*</span></label>
            <input 
              type="text" 
              v-model="form.nama_fee_mr" 
              @input="form.nama_fee_mr = form.nama_fee_mr.slice(0, 45)"
              placeholder="Masukkan Fee Marketing" 
              required 
            />
          </div>

          <div class="form-group">
            <label>Tipe Akad <span class="required">*</span></label>
            <div class="radio-group">
              <label class="radio-option">
                <input type="radio" name="tipe" value="1" v-model="form.tipe" required />
                <span class="radio-checkmark"></span>
                Konvensional
              </label>

              <label class="radio-option">
                <input type="radio" name="tipe" value="2" v-model="form.tipe" required />
                <span class="radio-checkmark"></span>
                Syariah
              </label>
            </div>
          </div>

          <!-- Indikator Loading -->
          <div v-if="loading" class="loading-box">
            <div class="spinner"></div>
            <span>Menyimpan data...</span>
          </div>

          <!-- Tombol Aksi -->
          <div class="form-actions" v-else>
            <button type="submit" class="btn primary">✅ Simpan Data</button>
            <router-link to="/nasabah" class="btn secondary">⬅ Batal</router-link>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import VueSelect from 'vue-select';
import 'vue-select/dist/vue-select.css'

export default {
  name: "NasabahAdd",
  components: {
    VueSelect
  },
  data() {
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    return {
      nama_bank: userData?.bank?.nama || '',
      kode_bank: userData?.kode_bank || null,
      form: {
        nopen: "",
        ktp_nasabah: "",
        nama_nasabah: "",
        tgl_pengajuan: "",
        tgl_pencairan: "",
        jenis_pengajuan: "",
        jenis_pk: "",
        bakidebet: 0,
        reber: 0,
        plafond: 0,
        jangka_waktu: "",
        cabang: "",
        jenis_produk: "",
        kerja_nasabah: "",
        tipe_debitur: "",
        nama_hs: "",
        nama_tl: "",
        nama_mr: "",
        nama_fee_mr: "",
        tipe: "1",
        takeoffer: false,
      },
      loading: false,
      arrTipeDebitur: [],
      arrCabang: [],
      arrJenisProduk: [],
      arrJenisPengajuan: [],
      displayPlafond: '',
      displayBakidebet: '',
      displayReber: '',
    };
  },
  mounted() {
    this.fetchCabang();
    this.fetchJenisProduk();
    this.fetchTipeDebitur();
    this.fetchJenisPengajuan();
  },
  methods: {
    fetchCabang() {
      fetch(`${this.$apiURL}/v1/get_cabang`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify({
          kode_bank: JSON.parse(localStorage.getItem("user") || "{}").bank.id
        })
      })
      .then(response => response.json())
      .then(result => { this.arrCabang = result || []; })
      .catch(err => console.error(err));
    },
    fetchJenisProduk() {
      fetch(`${this.$apiURL}/v1/get_jenis_produk`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
      })
      .then(response => response.json())
      .then(result => { this.arrJenisProduk = result || []; })
      .catch(err => console.error(err));
    },
    fetchTipeDebitur() {
      fetch(`${this.$apiURL}/v1/get_tipe_debitur`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
      })
      .then(response => response.json())
      .then(result => { this.arrTipeDebitur = result || []; })
      .catch(err => console.error(err));
    },
    fetchJenisPengajuan() {
      fetch(`${this.$apiURL}/v1/get_jenis_pengajuan`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
      })
      .then(response => response.json())
      .then(result => { this.arrJenisPengajuan = result || []; })
      .catch(err => console.error(err));
    },
    onSave() {
      this.loading = true;
      fetch(`${this.$apiURL}/v1/insert_nasabah`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify(this.form)
      })
      .then(response => response.json())
      .then((result) => {
        this.loading = false;
        if(result.success){
          Swal.fire({
            icon: 'success',
            title: 'Berhasil Ditembahkan!',
            text: 'Apakah Anda ingin menambahkan data lagi?',
            showDenyButton: true,
            confirmButtonColor: '#0b1953',
            denyButtonColor: '#f47b20',
            confirmButtonText: 'Ya, Tambah Lagi',
            denyButtonText: 'Kembali ke Data'
          }).then((res) => {
            this.resetForm();
            if (res.isDenied) {
              this.$router.push('/nasabah');
            }
          });
        }
      })
      .catch(err => {
        this.loading = false;
        console.error("Save error:", err);
      });
    },
    resetForm() {
      this.form = {
        nopen: "",
        ktp_nasabah: "",
        nama_nasabah: "",
        tgl_pengajuan: "",
        tgl_pencairan: "",
        jenis_pengajuan: "",
        jenis_pk: "",
        bakidebet: 0,
        reber: 0,
        plafond: 0,
        jangka_waktu: "",
        cabang: "",
        jenis_produk: "",
        kerja_nasabah: "",
        tipe_debitur: "",
        nama_hs: "",
        nama_tl: "",
        nama_mr: "",
        nama_fee_mr: "",
        tipe: "1",
        takeoffer: false,
      };
      this.displayPlafond = '';
      this.displayBakidebet = '';
      this.displayReber = '';
    },
    formatCurrency(e, field, displayField, maxLength = 15) {
      let numberOnly = e.target.value.replace(/\D/g, '').slice(0, maxLength);
      if (numberOnly === '') numberOnly = '0';

      this.form[field] = parseInt(numberOnly, 10);
      this[displayField] = new Intl.NumberFormat('id-ID').format(this.form[field]);
      e.target.value = this[displayField];
    },
    onReber() {
      if (this.form.bakidebet > 0) {
        this.form.reber = this.form.plafond - this.form.bakidebet;
      } else {
        this.form.reber = this.form.plafond;
      }
      this.displayReber = new Intl.NumberFormat('id-ID').format(this.form.reber);
    },
    formatNumber() {
      let angkaBersih = this.displayReber.replace(/[^0-9]/g, '');
      this.displayReber = new Intl.NumberFormat('id-ID').format(angkaBersih);
    }
  },
};
</script>

<style scoped>
.header-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 1px solid #edf2f7;
}

.header-bar h3 {
  margin: 0;
  font-size: 1.3rem;
  color: #0b1953;
  font-weight: 700;
}

.text-orange {
  color: #f47b20;
}

.form-container {
  margin: 0;
  padding: 0;
}

.form-group {
  margin-bottom: 1.2rem;
}

.required {
  color: #ef4444;
  margin-left: 2px;
}

.readonly-input {
  background-color: #f8fafc;
  color: #64748b;
  cursor: not-allowed;
}

.switch-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background-color: #f8fafc;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.form-actions button,
.form-actions a {
  padding: 0.6em 1.2em;
  font-size: 0.9rem;
}

/* Spinner Loading */
.loading-box {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  color: #0b1953;
  font-weight: 600;
}

.spinner {
  width: 24px;
  height: 24px;
  border: 3px solid #e2e8f0;
  border-top-color: #f47b20;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>